import "babel-polyfill"
import "react-app-polyfill/ie11";
import React from 'react'
import { createRoot } from 'react-dom/client'
import { HashRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async';
import config from './config'
import store from './store'
import ViewRouter from './router'
import { Provider } from 'react-redux'
import i18n from 'i18next'
import './i18n'
import './style/foot.less'
import './style/mstyle.less'
import './style/pop.less'
window.GLOBALCONFIG = {
    APIHOST: config[process.env.NODE_ENV as string]
}

const paramStr = window.location.hash.split('?')[1]
if (paramStr) {
    let paramList = paramStr.split('&')
    let params: Record<string, string> = {}
    paramList.map(item => {
        return params[item.split('=')[0]] = item.split('=')[1]
    })

    const defaultLanguage = localStorage.getItem('i18nextLng') || 'zh'
    const language = params.language || defaultLanguage
    i18n.changeLanguage(language)
    localStorage.setItem('i18nextLng', language)
} else {
    i18n.changeLanguage(localStorage.getItem('i18nextLng') || 'zh')
    localStorage.setItem('i18nextLng', localStorage.getItem('i18nextLng') || 'zh')
}

createRoot(document.getElementById('root')).render(
    <HelmetProvider>
        <React.StrictMode>
            <HashRouter>
                <Provider store={store}>
                    {/* 启用页面路由 */}
                    <ViewRouter></ViewRouter>
                </Provider>
            </HashRouter>
        </React.StrictMode>
    </HelmetProvider>
)